import City from './city';

import Entity from './entity';
export default class Customer extends Entity<number> {
  title: string;
  phone: string;
  cityId: number;
  districtId: number;
  email: string;
  address: string;
  taxOffice: string;
  taxNumber: string;
  city: City;
}
